import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import '../../../../../scss/weekpicker.css';
import '../../../../../scss/modernDatePicker.css';
import CustomCalendarPicker from '../../../../common/CustomWeekPicker/CustomCalendarPicker';
import CustomBiMonthlyPicker from '../../../../common/CustomBiMonthlyPicker/CustomBiMonthlyPicker';
import { getFirstDayOFMonth, getFirstDayofWeek } from '../../../../../utils/helpers';
import { calendarTypes } from '../../../../../utils/constants';
import CustomMonthPicker from '../../../../common/CustomMonthPicker/CustomMonthPicker';
import classes from './DateStep.module.scss';
import { submissionEnum } from '../../../../../utils/enums';
import CustomBiWeeklyPicker from '../../../../common/CustomBiWeeklyPicker/CustomBiWeeklyPicker';

export default function DateStep({
  setDate,
  type = submissionEnum.WEEKLY,
  choosedDate,
  choosedMonth,
  disabledBefore = false
}) {
  const { t } = useTranslation();
  const [month, setMonth] = useState(choosedMonth);
  const [year, setYear] = useState(dayjs().year());

  useEffect(() => {
    if (type === submissionEnum.MONTHLY && month && year) {
      const calculatedDate = getFirstDayOFMonth(new Date(year, month - 1).toString());
      if (calculatedDate !== choosedDate) {
        setDate(calculatedDate);
      }
    }
  }, [month, year, type]);

  const handlePickerChange = (date) => {
    if (!date) return;

    const transformedDate = getFirstDayofWeek(date);
    setDate(transformedDate);
  };
  return (
    <div className={classes.container}>
      <p className={classes.text}>
        {type === submissionEnum.WEEKLY && t('dashboard.createtimesheet.steps.selectweek')}
        {type === submissionEnum.MONTHLY && t('dashboard.createtimesheet.steps.selectmonth')}
        {type === submissionEnum.BI_MONTHLY && t('dashboard.createtimesheet.steps.selectbimonthly')}
        {type === submissionEnum.BI_WEEKLY && t('dashboard.createtimesheet.steps.selectbimonthly')}
      </p>
      {type === submissionEnum.WEEKLY && (
        <div className={classes.weekWrapper}>
          <CustomCalendarPicker
            userDate={choosedDate}
            setUserDate={handlePickerChange}
            calendarType={calendarTypes.WEEK}
            backgroundColor="#FEFEFE"
            disabledBeforeIncluded={disabledBefore}
          />
        </div>
      )}
      {type === submissionEnum.MONTHLY && (
        <CustomMonthPicker
          month={month}
          year={year}
          setMonth={setMonth}
          setYear={setYear}
          backgroundColor="#FEFEFE"
          disabledBeforeIncluded={disabledBefore}
        />
      )}
      {type === submissionEnum.BI_MONTHLY && (
        <div className={classes.weekWrapper}>
          <CustomBiMonthlyPicker
            userDate={choosedDate}
            setUserDate={setDate}
            calendarType={calendarTypes.WEEK}
            backgroundColor="#FFF"
            disabledBeforeIncluded={disabledBefore}
          />
        </div>
      )}
      {type === submissionEnum.BI_WEEKLY && (
        <div className={classes.weekWrapper}>
          <CustomBiWeeklyPicker
            userDate={choosedDate}
            setUserDate={setDate}
            calendarType={calendarTypes.WEEK}
            backgroundColor="#FFF"
            disabledBeforeIncluded={disabledBefore}
          />
        </div>
      )}
    </div>
  );
}
